import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomPropTypes from '../../util/custom-prop-types';
import { TextMixin } from '../../mixins/components/TextMixin';
import { FONT_TYPES } from '../../constants/FONT_TYPES';
/**
 * Use this component for rendering any text to the page.
 * By default it will create a `<span>` with body type ramp.
 *
 * **Note: since `<span>` is inline,**
 * **this component will not work with top and bottom `spacing` props.**
 * Use the block level [`Paragraph`](#/Typography%20components?id=paragraph) component instead,
 * or see the [spacing](#spacing) documentation for other alternatives.
 *
 * See also [`Paragraph`](#/Typography%20components?id=paragraph),
 * [`Heading`](#/Typography%20components?id=heading)
 *
 * @since 6.0.0
 */

var Text = /*#__PURE__*/styled.span.withConfig({
  displayName: "Text",
  componentId: "c11n-8-64-0__sc-aiai24-0"
})(["", ""], TextMixin);
Text.propTypes = {
  /**
   * A [color token](#/%40zillow%2Fconstellation/Tokens?id=section-colors),
   * e.g. `'textDark'`, `'textWhite'`.
   * Set this to an empty string to remove color styles.
   */
  fontColor: PropTypes.string,

  /**
   * The font type of the text determines the size, weight, and line-height.
   *
   * Supports [inline media query objects](#/Media%20queries)
   */
  fontType: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.keys(FONT_TYPES))),

  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
Text.defaultProps = {
  fontColor: 'textDark',
  fontType: FONT_TYPES.body
};
/** @component */

export default Text;
export var StyledText = Text;